import { Star } from 'lucide-react';

export default function Rating() {
  return (
    <div className="flex flex-col items-center space-y-3">
      <div className="flex items-center space-x-1">
        {[...Array(4)].map((_, i) => (
          <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
        ))}

        <div className="relative">
          <Star className="w-4 h-4 text-yellow-400" />
          <div
            className="absolute inset-0 overflow-hidden"
            style={{ width: '60%' }}
          >
            <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" />
          </div>
        </div>

        <span className="ml-2 text-sm font-medium">4.8/5</span>
      </div>

      <p className="text-xs text-center text-slate-500 max-w-xs">
        Trusted by <span className="font-semibold text-slate-600">10,000+</span>{' '}
        satisfied customers who love our exceptional service and support.
      </p>
    </div>
  );
}
